@let presentPageConfiguration = store.presentPageConfigurationSg();

@if (presentPageConfiguration) {
  <atn-ds-centered-overlay type="full-width">
    <div class="atn-mosaic-page-configuration-dialog">
      <atn-ds-widget title="Configure Page">
        <div actions>
          <!-- TODO: Run query button should be added -->
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </div>

        <div class="atn-mosaic-page-configuration-dialog__body">
          <atn-ds-integrated-horizontal-tabs>
            <ng-template
              atnDsTab
              name="General"
            >
              <atn-page-configuration-general-tab />
            </ng-template>
            <ng-template
              atnDsTab
              name="Query"
            >
              <atn-page-configuration-query-tab />
            </ng-template>
            <ng-template
              atnDsTab
              name="Variables"
            >
              <atn-variables-builder />
            </ng-template>
          </atn-ds-integrated-horizontal-tabs>
        </div>

        <div
          footer
          class="atn-mosaic-page-configuration-dialog__footer"
        >
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
            >Cancel</atn-ds-button
          >
          <atn-ds-button (click)="saveClickHandler()"> Save </atn-ds-button>
        </div>
      </atn-ds-widget>
    </div>
  </atn-ds-centered-overlay>
}
